const DEV_NEWS_URL = 'http://localhost:8080/news';
const PROD_NEWS_URL = 'https://keyfiyathava.ahooai.ir/news';

export const NEWS_URL = __DEV__ ? DEV_NEWS_URL : PROD_NEWS_URL;
